<footer class="pt-0 pb-4 pt-lg-3 pb-lg-3">
    <div class="container">
        <div class="row d-none d-lg-block">
            <div class="col-12">
                <h2 class="th pb-2 header-line">
                    <span>ติดตามเราได้ที่</span>
                </h2>
                <h2 class="en pb-2 header-line">
                    <span>Find Us On</span>
                </h2>
                <div class="footer-social">
                    <a href="https://www.facebook.com/MGcarsThailand/" target="_blank"><img class="imghover"
                            src="https://www.mgcars.com/images/facebook-icon.png" alt=""></a>
                    <a href="https://www.youtube.com/channel/UCWBomBcUxilPt-H3mqjpdQA" target="_blank"><img
                            class="imghover" src="https://www.mgcars.com/images/youtube-icon.png" alt=""></a>
                    <a href="https://www.instagram.com/mgthailand/" target="_blank"><img class="imghover"
                            src="https://www.mgcars.com/images/instagram-icon.png" alt=""></a>
                    <a href="https://lin.ee/cpQc5GA" target="_blank"><img class="imghover"
                            src="https://www.mgcars.com/images/line.png" alt=""></a>
                </div>
            </div>
        </div>
        <div class="row pt-4">
            <div class="col-8 d-none d-lg-block">
                <div class="row">
                    <div class="col-4">
                        <ul class="th footer-border-left">
                            <li><a href="https://www.mgcars.com/th/Home">หน้าแรก</a></li>
                            <li><a href="#" class="footer-models">รุ่นรถ</a></li>
                            <li><a href="https://www.mgcars.com/th/Promotion">โปรโมชัน</a></li>
                            <li><a href="https://www.mgcars.com/th/MGFleetSale">ลูกค้าองค์กร</a></li>
                            <li><a href="https://www.mgcars.com/th/AfterSalesService">บริการหลังการขาย</a></li>
                            <li><a href="https://www.mgcars.com/th/Calculator">คำนวณราคา</a></li>
                        </ul>
                        <ul class="en footer-border-left">
                            <li><a href="https://www.mgcars.com/en/Home">Home</a></li>
                            <li><a href="#" class="footer-models">MG Models</a></li>
                            <li><a href="https://www.mgcars.com/en/Promotion">PROMOTION</a></li>
                            <li><a href="https://www.mgcars.com/en/MGFleetSale">MG FLEET SALES</a></li>
                            <li><a href="https://www.mgcars.com/en/AfterSalesService">AFTER SALES SERVICES</a></li>
                            <li><a href="https://www.mgcars.com/en/Calculator">PRICE CALCULATION</a></li>
                        </ul>
                    </div>
                    <div class="th col-4">
                        <ul>
                            <li><a href="https://www.mgcars.com/th/innovation/ismart">นวัตกรรม</a></li>
                            <li><a href="https://www.mgcars.com/th/NewsActivities">ข่าวสาร &amp; กิจกรรม</a>
                            </li>
                            <li><a href="https://www.mgcars.com/th/Overview">เกี่ยวกับเรา</a></li>
                            <li><a href="https://www.mgcars.com/th/TestDrive">ทดลองขับเอ็มจี</a></li>
                            <li><a href="https://www.mgcars.com/th/RequestBrochure">ขอรับโบรชัวร์</a></li>
                            <li><a href="https://www.mgcars.com/th/RequestQuotation">ขอรับใบเสนอราคา</a></li>
                        </ul>
                    </div>
                    <div class="en col-4">
                        <ul>
                            <li><a href="https://www.mgcars.com/en/innovation/ismart">INNOVATIONS</a></li>
                            <li><a href="https://www.mgcars.com/en/NewsActivities">NEWS & ACTIVITIES</a>
                            </li>
                            <li><a href="https://www.mgcars.com/en/Overview">ABOUT MG</a></li>
                            <li><a href="https://www.mgcars.com/en/TestDrive">TEST DRIVE</a></li>
                            <li><a href="https://www.mgcars.com/en/RequestBrochure">REQUEST A BROCHURE</a></li>
                            <li><a href="https://www.mgcars.com/en/RequestQuotation">REQUEST QUOTATION</a></li>
                        </ul>
                    </div>
                    <div class="th col-4">
                        <ul>
                            <li><a href="https://www.mgcars.com/th/Dealer">ผู้จำหน่ายเอ็มจี</a></li>
                            <li><a href="https://www.mgcars.com/th/ContactUs">ติดต่อเรา</a></li>
                            <li><a href="https://www.mgcars.com/th/Faq">คำถามที่พบบ่อย</a></li>
                            <li><a href="https://www.mgcars.com/th/Career">ร่วมงานกับเรา</a></li>
                            <li><a
                                    href="https://www.mgcars.com/th/DrivingExperienceCentre">ศูนย์สร้างประสบการณ์<br>การขับขี่รถยนต์เอ็มจี</a>
                            </li>
                        </ul>
                    </div>
                    <div class="en col-4">
                        <ul>
                            <li><a href="https://www.mgcars.com/en/Dealer">DEALERS</a></li>
                            <li><a href="https://www.mgcars.com/en/ContactUs">CONTACT US</a></li>
                            <li><a href="https://www.mgcars.com/en/Faq">FAQ</a></li>
                            <li><a href="https://www.mgcars.com/en/Career">CAREER</a></li>
                            <li><a href="https://www.mgcars.com/en/DrivingExperienceCentre">MG DRIVING EXPERIENCE
                                    <br>CENTRE</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <h2 class="th text-center text-lg-left">สมัครรับจดหมายข่าว</h2>
                <h2 class="en text-center text-lg-left">SUBSCRIBE TO E-NEWS</h2>
                <form id="subscribe-footer" class="subscribe-footer">
                    <input type="email" class="subscribe-input" id="subscribe" placeholder="Email" name="Email">
                    <button type="submit" class="subscribe-icon">
                        <picture>
                            <source media="(min-width: 992px)" srcset="https://www.mgcars.com/images/subscribe-ion.png">
                            <img src="https://www.mgcars.com/images/subscribe-ion-mobile.png" alt="" class="img-fluid">
                        </picture>
                    </button>
                </form>
                <div class="row mt-3 d-none d-lg-flex">
                    <div class="col-6">
                        <a class="th join-our-dealership" href="https://www.mgcars.com/th/NetworkExpansion"
                            role="button">ร่วมเป็นหนึ่งในผู้จำหน่ายของเรา</a>
                        <a class="en join-our-dealership" href="https://www.mgcars.com/th/NetworkExpansion"
                            role="button">Join Our Dealership</a>
                    </div>
                    <div class="th col-6 call">
                        ศูนย์บริการลูกค้า 24 ชม. <br> โทร. <a href="tel:1267">1267</a></div>
                    <div class="en col-6 call">
                        24/7 Call Centre <br> Call <a href="tel:1267">1267</a></div>
                </div>
            </div>
            <div class="col-12 d-block d-lg-none mt-3 mt-3">
                <div class="footer-social text-center">
                    <a href="https://www.facebook.com/MGcarsThailand/" target="_blank"><img
                            src="https://www.mgcars.com/images/facebook-icon-mobile1.png" alt=""></a>
                    <a href="https://www.youtube.com/channel/UCWBomBcUxilPt-H3mqjpdQA" target="_blank"><img
                            src="https://www.mgcars.com/images/youtube-icon-mobile1.png" alt=""></a>
                    <a href="https://www.instagram.com/mgthailand/" target="_blank"><img
                            src="https://www.mgcars.com/images/instagram-icon-mobile1.png" alt=""></a>
                    <a href="https://lin.ee/cpQc5GA" target="_blank"><img
                            src="https://www.mgcars.com/images/line-icon-mobile.png" alt=""></a>
                    <a href="tel:1267" target="_blank"><img src="https://www.mgcars.com/images/call-center-mobile.png"
                            alt=""></a>
                </div>
            </div>
        </div>
        <div class="row mt-2 mb-2 d-none d-lg-block">
            <div class="col-8 offset-2">
                <hr>
            </div>
        </div>
        <div class="row pb-4 d-none d-lg-flex">
            <div class="col-6">
                &copy; 2019 MG SALES (THAILAND) CO., LTD.</div>
            <div class="th col-6 text-right site-map">
                <a href="https://www.mgcars.com/th/PrivacyAndTerm">นโยบายความเป็นส่วนตัว</a> | <a
                    href="https://www.mgcars.com/th/Sitemap">โครงสร้างเว็บไซต์</a>
            </div>
            <div class="en col-6 text-right site-map">
                <a href="https://www.mgcars.com/th/PrivacyAndTerm">PRIVACY & TERMS</a> | <a
                    href="https://www.mgcars.com/th/Sitemap">SITE MAP</a>
            </div>
        </div>
    </div>
</footer>